import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";
import PageSpinner from "../../elements/spinner/PageSpinner";
import Notification from "../../elements/notification/Notification";
import { StyledWalletDetailsWrapper } from "../styledWallets";
import { Helmet } from "react-helmet-async";
import { StyledContentWrapper } from "../../styles/styledMain";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { CopyToClipboard } from "react-copy-to-clipboard/lib/Component";
import { useTranslation } from "react-i18next";
import WalletTabContainer from "./walletDetails/WalletTabContainer";

const WalletDetailsContainer = ({ match }) => {
  const { t } = useTranslation("clientsPage");

  const history = useHistory();

  let [walletDetails, setWalletDetails] = useState(null);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchWalletDetails = () => {
    axios.get("/api/wallets/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setWalletDetails(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  useEffect(() => {
    fetchWalletDetails();
  }, []);

  if (!walletDetails) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />

      <Helmet>
        <title>{walletDetails.currency} {walletDetails.paymentSystem} wallet • eXsoft.io</title>
      </Helmet>
      <StyledWalletDetailsWrapper>
        <StyledContentWrapper height="auto" className="wallet-details-head">
          <GoToBackButton pt="20" pb="30" handler={() => {history.goBack();}} />
          <div className="wallet-info">
            <div className="currency">
              <div className="currency__image">
                {walletDetails.currency.charAt(0)}
              </div>
              <div className="currency__name">
                {walletDetails.currency} {walletDetails.paymentSystem}
              </div>
            </div>
            <div className="wallet-info__content">
              <div className="wallet-info__row" title="Balance">
                <span className="icon-light-payment" />
                <p>
                  {walletDetails.balance}
                </p>
              </div>
              <div className="wallet-info__row" title="Project">
                <span className="icon-light-projects" />
                <p>
                  {walletDetails.connection.project.name}
                </p>
              </div>
              <div className="wallet-info__row" title="Service">
                <span className="icon-light-add-connection" />
                <p>
                  {walletDetails.connection.service.name}
                </p>
              </div>
              <div className="wallet-info__row" title="Wallet">
                <span className="icon-light-wallet" />
                <CopyToClipboard
                  text={walletDetails.wallet}
                  onCopy={() => {
                    setNotification({ ...notification, visible: true, type: "success", message: t("details.copied") });
                  }}
                >
                  <p>
                    {walletDetails.wallet}
                  </p>
                </CopyToClipboard>
              </div>
              <div className="wallet-info__row" title="Tag/memo">
                <span className="icon-light-wallet" />
                {walletDetails.tag ? (
                  <CopyToClipboard
                    text={walletDetails.tag}
                    onCopy={() => {
                      setNotification({
                        ...notification,
                        visible: true,
                        type: "success",
                        message: t("details.copied")
                      });
                    }}
                  >
                    <p>
                      {walletDetails.tag}
                    </p>
                  </CopyToClipboard>
                ) : "--"}
              </div>
            </div>
          </div>
        </StyledContentWrapper>
        <WalletTabContainer match={match} t={t}/>
      </StyledWalletDetailsWrapper>
    </>
  );
};

export default WalletDetailsContainer;